import ApiClient, { CustomHeaders } from "./apiClient";

/**
 * Centralized API instances for the application.
 * Manages separate clients for Admin and User contexts with their respective tokens and login paths.
 */

export const ADMIN_BASE_URL = `${process.env.REACT_APP_API_ADMIN_BASE_URL}/api/v1`;
export const USER_BASE_URL = `${process.env.REACT_APP_API_USER_BASE_URL}/api/v1`;

// Admin API Clients
const adminClient = new ApiClient({
    baseURL: ADMIN_BASE_URL,
    tokenKey: "saca_admin_token",
    loginPath: "/admin-login",
    silent: false,
});

const adminSilentClient = new ApiClient({
    baseURL: ADMIN_BASE_URL,
    tokenKey: "saca_admin_token",
    loginPath: "/admin-login",
    silent: true,
});

// User API Clients
const userClient = new ApiClient({
    baseURL: USER_BASE_URL,
    tokenKey: "saca_token",
    loginPath: "/sign-in",
    silent: false,
});

const userSilentClient = new ApiClient({
    baseURL: USER_BASE_URL,
    tokenKey: "saca_token",
    loginPath: "/sign-in",
    silent: true,
});

/**
 * Standard Admin API request (shows success/error snackbars)
 */
export const adminApi = <T = unknown>(method: string, uri: string, body: unknown = null, headers: CustomHeaders = {}) =>
    adminClient.request<T>(method, uri, body, headers);

/**
 * Silent Admin API request (suppresses snackbars)
 */
export const adminSilentApi = <T = unknown>(method: string, uri: string, body: unknown = null, headers: CustomHeaders = {}) =>
    adminSilentClient.request<T>(method, uri, body, headers);

/**
 * Standard User API request (shows success/error snackbars)
 */
export const userApi = <T = unknown>(method: string, uri: string, body: unknown = null, headers: CustomHeaders = {}) =>
    userClient.request<T>(method, uri, body, headers);

/**
 * Silent User API request (suppresses snackbars)
 */
export const userSilentApi = <T = unknown>(method: string, uri: string, body: unknown = null, headers: CustomHeaders = {}) =>
    userSilentClient.request<T>(method, uri, body, headers);

// Default export as userApi for common usage
export default userApi;
